import * as React from 'react';
import {Subheading} from '@packages/systems/design-system/Text';
import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';
import {TypeImplementation} from '@packages/systems/wfdl';
import {TTypeReference} from '@packages/systems/wfdl-ast';

const a = TTypeReference('a');

/**
 * All the compatible custom fields of a CMS collection, rendered below Basic Info Fields
 */
export const CustomFieldsType = TypeImplementation.Alias({
  params: ['a'],
  system: {bindUIVariant: 'custom'},
  type: a,
  render: function CustomFields({expr, dispatch}) {
    return (
      <>
        <Subheading>Custom Fields</Subheading>
        <ExpressionEditor expression={expr} dispatch={dispatch} />
      </>
    );
  },
});
